import { useCallback, useState } from 'react';

import type { StatementListItem } from '../types/Statements.types';

export const useStatementQuickView = () => {
  const [selectedStatement, setSelectedStatement] = useState<StatementListItem | null>(null);

  const openQuickView = useCallback((statement: StatementListItem) => {
    setSelectedStatement(statement);
  }, []);

  const closeQuickView = useCallback(() => {
    setSelectedStatement(null);
  }, []);

  return {
    selectedStatement,
    openQuickView,
    closeQuickView,
  };
};
